import { guideApi, type GuideHistoryMessage } from "../api/guide";

export const guideService = {
  getWelcome(eventId: string, lang?: string) {
    return guideApi.getWelcome(eventId, lang);
  },

  send(eventId: string, message: string, history: GuideHistoryMessage[], lang?: string) {
    return guideApi.sendMessage(eventId, { message, history, lang });
  },

  escalate(eventId: string, lang?: string, message?: string) {
    return guideApi.escalate(eventId, lang, message);
  },
};
